import { request } from './request';

export const getAllTechnicians = () => request('technicians');
export const getTechnicianById = (id) => request(`technicians/${id}`);
export const createTechnician = (body) =>
  request(
    `technicians`,
    {
      method: 'POST',
      body,
    },
    'Invitation link was sent to the user!',
  );

export const updateTechnician = (id, body) =>
  request(
    `technicians/${id}`,
    {
      method: 'PATCH',
      body,
    },
    'Technician updated successfully!',
  );
